'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#20_svg__clip0_39877_64209)" },
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.54736 2.3783C4.94343 1.91764 5.63794 1.86528 6.09859 2.26135L14.4538 9.44506C14.4652 9.45487 14.4768 9.46484 14.4886 9.47493C14.6619 9.62373 14.8695 9.80197 15.0247 9.9789C15.2109 10.1911 15.4516 10.5428 15.4516 11.0374C15.4516 11.532 15.2109 11.8837 15.0247 12.0959C14.8695 12.2728 14.6619 12.4511 14.4886 12.5999C14.4768 12.61 14.4652 12.6199 14.4538 12.6298L6.17176 19.7507C5.71111 20.1468 5.0166 20.0944 4.62053 19.6338C4.22446 19.1731 4.27681 18.4786 4.73746 18.0825L12.9313 11.0374L4.66431 3.92953C4.20365 3.53346 4.1513 2.83895 4.54736 2.3783Z", fill: props.fillColor, fillOpacity: 0.92 })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "20_svg__clip0_39877_64209" },
            React__namespace.createElement("rect", { width: 20, height: 20, fill: "white", transform: "translate(0 0.994873)" })))));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
